export enum RoleEnum {
    Admin = 1,
    Customer = 2,
    Auctioneer = 3,
    Monitor = 4,
    ProxyBidder = 5

}

export enum RoleStringEnum {
    Admin = "Admin",
    Customer = "Customer",
    Auctioneer = "Auctioneer",
    Monitor = "Monitor",
    ProxyBidder = "ProxyBidder"
}
